/**
 * Master Muscles — Shopify product recommendations (complementary + related)
 * Same algorithm as Also Bought / cart sheet recommendations.
 */
(function () {
  'use strict';

  function pathLocalePrefix() {
    var p = window.location.pathname;
    var m = p.match(/^(\/[a-z]{2}(-[a-z]{2})?)\//i);
    return m ? m[1] : '';
  }

  /** Active storefront language (ar, en, …) from Liquid / html lang. */
  function getLanguageCode() {
    try {
      var el = document.getElementById('mm-currency-config');
      if (el) {
        var cfg = JSON.parse(el.textContent);
        if (cfg && cfg.language) return String(cfg.language).toLowerCase();
      }
    } catch (e) {
      /* ignore */
    }
    if (document.documentElement && document.documentElement.lang) {
      return document.documentElement.lang.split('-')[0].toLowerCase();
    }
    var fromPath = pathLocalePrefix();
    if (fromPath) return fromPath.replace(/^\//, '').toLowerCase();
    return '';
  }

  /** Locale-aware root for Ajax API (e.g. `/` or `/ar/`). */
  function apiRoot() {
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      var root = window.Shopify.routes.root;
      if (root.charAt(0) !== '/') root = '/' + root;
      if (root.slice(-1) !== '/') root += '/';
      return root;
    }

    var lang = getLanguageCode();
    if (lang && lang !== 'en') return '/' + lang + '/';

    var prefix = pathLocalePrefix();
    if (prefix) return prefix + '/';

    return '/';
  }

  function fetchHeaders() {
    var lang = getLanguageCode();
    var headers = { Accept: 'application/json' };
    if (lang) headers['Accept-Language'] = lang;
    return headers;
  }

  /** Storefront product URL — avoids broken / doubled locale prefixes from API `url`. */
  function productPageUrl(product) {
    var handle = product && product.handle;
    if (!handle) return '#';
    return apiRoot() + 'products/' + handle;
  }

  function fetchOne(id, intent, limit) {
    return fetch(
      apiRoot() +
        'recommendations/products.json?product_id=' +
        id +
        '&limit=' +
        (limit || 8) +
        '&intent=' +
        intent,
      { credentials: 'same-origin', headers: fetchHeaders() }
    )
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .then(function (d) {
        return d.products || [];
      })
      .catch(function () {
        return [];
      });
  }

  function parseMoneyMinor(val) {
    var n = parseInt(val, 10);
    return isNaN(n) ? 0 : n;
  }

  function isVariantAvailable(variant) {
    return !!(variant && variant.available === true);
  }

  function isProductPurchasable(product) {
    if (!product || !product.variants || !product.variants.length) return false;
    if (product.available === false) return false;
    return product.variants.some(isVariantAvailable);
  }

  function getAvailableVariants(product) {
    if (!product || !product.variants) return [];
    return product.variants.filter(isVariantAvailable);
  }

  function getDefaultVariant(product) {
    var available = getAvailableVariants(product);
    if (!available.length) return null;
    var onSale = available.find(function (vr) {
      var price = parseMoneyMinor(vr.price);
      var compareAt = parseMoneyMinor(vr.compare_at_price);
      return compareAt > price;
    });
    return onSale || available[0];
  }

  /**
   * Sale pricing for a specific available variant only (avoids product-level compare_at flicker).
   */
  function getDisplayPricing(product, activeVariant) {
    if (!product) return null;
    var v = activeVariant;
    if (v && !isVariantAvailable(v)) v = null;
    if (!v) v = getDefaultVariant(product);
    if (!v) return null;

    var price = parseMoneyMinor(v.price);
    var compareAt = parseMoneyMinor(v.compare_at_price);
    var onSale = compareAt > price;

    return {
      variant: v,
      price: price,
      compareAt: onSale ? compareAt : 0,
      onSale: onSale,
      discountPct: onSale ? Math.round(((compareAt - price) / compareAt) * 100) : 0,
    };
  }

  function fetchRecommendations(productIds, limit) {
    var seen = {};
    var merged = [];
    var intents = ['complementary', 'related'];
    var ids = (productIds || []).slice(0, 3);
    var want = limit || 8;
    var fetchLimit = Math.max(want * 3, 12);

    (productIds || []).forEach(function (id) {
      seen[id] = true;
    });

    if (!ids.length) return Promise.resolve([]);

    var chain = Promise.resolve();
    ids.forEach(function (id) {
      intents.forEach(function (intent) {
        chain = chain.then(function () {
          return fetchOne(id, intent, fetchLimit).then(function (products) {
            products.forEach(function (p) {
              if (!seen[p.id]) {
                seen[p.id] = true;
                merged.push(p);
              }
            });
          });
        });
      });
    });

    return chain.then(function () {
      return merged.filter(isProductPurchasable).slice(0, want);
    });
  }

  window.MMRecommendations = {
    fetch: fetchRecommendations,
    productUrl: productPageUrl,
    apiRoot: apiRoot,
    getLanguageCode: getLanguageCode,
    parseMoneyMinor: parseMoneyMinor,
    isVariantAvailable: isVariantAvailable,
    isProductPurchasable: isProductPurchasable,
    getAvailableVariants: getAvailableVariants,
    getDefaultVariant: getDefaultVariant,
    getDisplayPricing: getDisplayPricing,
  };
})();
